<script setup lang="ts">
import type { EventTimeFilter } from '../lib/const';
import EventsTabBar from './EventsTabBar.vue';
import { EventsCalendarDropdown } from '~/widgets/events-calendar';

defineProps<{
  timeFilter: EventTimeFilter;
  showTimeFilter: boolean;
}>();

const emit = defineEmits<{
  changeTimeFilter: [value: EventTimeFilter];
}>();
</script>

<template>
  <div :class="$style.topBar">
    <div :class="$style.breadcrumbs">
      <NuxtLink to="/" :class="$style.breadcrumbLink">ГЛАВНАЯ</NuxtLink>
      <span> / </span>
      <span>МЕРОПРИЯТИЯ</span>
    </div>
    <div :class="$style.titleRow">
      <h1 :class="$style.title">Мероприятия</h1>
      <EventsTabBar
        v-if="showTimeFilter"
        :active="timeFilter"
        @change="emit('changeTimeFilter', $event)"
      />
      <EventsCalendarDropdown />
    </div>
  </div>
</template>

<style module lang="scss">
.topBar {
  display: flex;
  flex-direction: column;
  background-color: var(--color-gray-bg);
  padding: var(--space-2-5x);
}

.breadcrumbs {
  @include text_caption1_caps;
  color: var(--color-gray-text);
  margin-bottom: 14px;
}

.breadcrumbLink {
  color: var(--color-gray-text);
  text-decoration: none;

  &:hover {
    color: var(--color-red-1);
  }
}

.titleRow {
  display: flex;
  align-items: flex-end;
  gap: var(--space-2x);
}

.title {
  @include text_h1;
  color: var(--color-black-1);
  margin: 0 var(--space-2-5x) 0 0;
  white-space: nowrap;
}

@media (max-width: 1379px) {
  .titleRow {
    flex-wrap: wrap;
    row-gap: var(--space-2-5x);
  }

  .title {
    flex: 0 0 100%;
    margin-right: 0;
    @include text_h4;
  }
}

@media (max-width: 599px) {
  .title {
    @include text_h5;
  }
}

@media (max-width: 479px) {
  .breadcrumbs {
    font-size: 8px;
    letter-spacing: 0.8px;
    margin-bottom: 12px;
  }
}
</style>
